import { FC, PropsWithChildren, useState } from "react";
import usePopup from "../../../hooks/usePopup";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  IconButton,
  Tooltip,
  TableContainer,
} from "@mui/material";
import ListAltIcon from "@mui/icons-material/ListAlt";
import { LogComponentType } from "./types";
import { useMutation } from "react-query";
import { getLogsDetails } from "../../services";
import { useParams } from "react-router-dom";
import CustomTableBody from "../../../utilis/component/CustomTableBody";
import { formatLocalDateTime } from "../../../utilis/methods/localDateTime";
const LogComonent: FC<PropsWithChildren<LogComponentType>> = ({
  title,
  field,
  id
}) => {
  const {showSnackbar,CustomModal} = usePopup()
  const { encounterId } = useParams();
  const [open, setOpen] = useState<boolean>(false);

  const { mutate: fetchLogsDetails, data: logs,isLoading } = useMutation(getLogsDetails,{
    onSuccess:(result)=>{
       if(result.responseIndicator == "fail"){
        showSnackbar({message:result.responseMessage,open:true,variant:"warning"})
       }
    }
  });

  const handleOpenLog = () => {
    setOpen(true);
    fetchLogsDetails({ field, encounterId: (id ? String(id) : encounterId  ) as string });
  };

  return (
    <span className="hidden">
      <CustomModal title={`${title} log`} open={open} setOpen={setOpen}>
        <TableContainer className="max-h-[65dvh] relative">
        <Table size="small" sx={{ minWidth: 650,maxWidth:"85vw"}} aria-label="simple table">
          <TableHead className="sticky top-0 z-[999]" sx={(theme)=>({backgroundColor:theme.palette.background.paper})}>
            <TableRow>
              {headings.map((heading, index) => (
                <TableCell key={`${title}Logs${index}`}><strong>{heading}</strong></TableCell>
              ))}
            </TableRow>
          </TableHead>
          <CustomTableBody alert={"No records"} dataLoading={isLoading} isData={Boolean(logs?.response?.length)} totalSpan={{col:headings.length,row:10}}>
            {logs?.response?.map((log, index) => (
              <TableRow sx={(theme)=>({
                '&:nth-of-type(odd)': {
                  backgroundColor: theme.palette.action.hover,
                },
                // hide last border
                '&:last-child td, &:last-child th': {
                  border: 0,
                },
              })}>
                <TableCell key={`${field}log${index}`}>{log.id}</TableCell>
                <TableCell>{log.actionType}</TableCell>
                <TableCell sx={{maxWidth:"300px"}}>{String(log?.newValue || "").replace(/#\$/g, " ")}</TableCell>
                <TableCell sx={{maxWidth:"300px"}} >{String(log?.oldValue || "").replace(/#\$/g, " ")}</TableCell>
                <TableCell>{log.fieldName}</TableCell>
                <TableCell sx={{maxWidth:"300px"}}>
                  {formatLocalDateTime(log.timeStamp)}
                </TableCell>
                <TableCell sx={{maxWidth:"300px"}}>{log.user}</TableCell>
              </TableRow>
            ))}
           
          </CustomTableBody>
        </Table>
        </TableContainer>
      </CustomModal>
      <Tooltip title={`${title} log`}>
        <IconButton
          color="primary"
          onClick={handleOpenLog}
        >
          <ListAltIcon />
        </IconButton>
      </Tooltip>
    </span>
  );
};

export default LogComonent;
const headings = ["Slno", "Action type", "New value","Old value","Affected field", "Time", "Modified by"];
